import React from 'react'
import { ContactCard } from '../ContactCard'
import { ISocietyContactWithFiles } from '../../../interfaces/services/society-contacts.interface'

interface ContactListProps {
  contacts: ISocietyContactWithFiles[]
  management: boolean
}

export const ContactList = ({
  contacts,
  management,
}: ContactListProps): JSX.Element => {
  return (
    <div className="flex flex-row flex-wrap gap-8 pb-4">
      {contacts.map((contact) => (
        <ContactCard
          key={contact._id}
          contact={contact}
          management={management}
        />
      ))}
    </div>
  )
}
